import { render, staticRenderFns } from "./EventDetectionHighCoverageDataTable.vue?vue&type=template&id=230e46c5&scoped=true"
import script from "./EventDetectionHighCoverageDataTable.vue?vue&type=script&lang=js"
export * from "./EventDetectionHighCoverageDataTable.vue?vue&type=script&lang=js"
import style0 from "./EventDetectionHighCoverageDataTable.vue?vue&type=style&index=0&id=230e46c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e46c5",
  null
  
)

export default component.exports